import { Attendance } from "@local-types/attendance/tableRow";
import { API_BASE_URL } from "./config";

export const fetchAttendances = async (): Promise<Attendance[]> => {
  const response = await fetch(`${API_BASE_URL}/attendances`);
  if (!response.ok) {
    throw new Error("Ошибка загрузки посещений");
  }
  return response.json();
};

export const createAttendance = async (
  attendance: Omit<Attendance, "id">,
): Promise<Attendance> => {
  const response = await fetch(`${API_BASE_URL}/attendances`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(attendance),
  });

  if (!response.ok) {
    throw new Error("Ошибка создания посещения");
  }

  return response.json();
};

export const deleteAttendance = async (id: number): Promise<void> => {
  const response = await fetch(`${API_BASE_URL}/attendances/${id}`, {
    method: "DELETE",
  });

  if (!response.ok) {
    throw new Error("Ошибка удаления посещения");
  }
};

export const updateAttendance = async (
  id: number,
  updates: Partial<Attendance>,
): Promise<Attendance> => {
  const response = await fetch(`${API_BASE_URL}/attendances/${id}`, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(updates),
  });

  if (!response.ok) {
    throw new Error("Ошибка обновления посещения");
  }

  return response.json();
};

export const createAttendancesForParticipants = async (
  participant_ids: number[],
  date: string,
  isPaid: boolean,
  amount: number,
  direction_id?: number | null,
): Promise<Attendance[]> => {
  const response = await fetch(
    `${API_BASE_URL}/attendances/bulk-participants`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        participant_ids,
        date,
        isPaid,
        amount,
        direction_id,
      }),
    },
  );

  if (!response.ok) {
    throw new Error("Ошибка массового создания посещений");
  }

  return response.json();
};

export const createAttendancesForDates = async (
  participant_id: number,
  dates: string[],
  isPaid: boolean,
  amount: number,
  direction_id?: number | null,
): Promise<Attendance[]> => {
  const response = await fetch(`${API_BASE_URL}/attendances/bulk-dates`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      participant_id,
      dates,
      isPaid,
      amount,
      direction_id,
    }),
  });

  if (!response.ok) {
    throw new Error("Ошибка массового создания посещений");
  }

  return response.json();
};

export const updateAttendanceAmounts = async (
  year: number,
  month: number,
  newAmount: number,
  participant_id?: number,
): Promise<Attendance[]> => {
  const response = await fetch(`${API_BASE_URL}/attendances/update-amounts`, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ year, month, newAmount, participant_id }),
  });

  if (!response.ok) {
    throw new Error("Ошибка обновления стоимости посещений");
  }

  return response.json();
};
